var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section",style:(_vm.hasBorder ? _vm.setBorder: '')},[_c('pre',{staticClass:"section__link",style:(_vm.setStyle),domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }